const ROUTES = {
	LANDING: "/",
	HOME: "/home",
	CONTACT: "/contact",
	ABOUT: "/about",
	HELP: "/help",
	REFERRALS: "/referrals",
	COMMUNITY: "/c",
	GROUP: "/g",
	FAQ: "/faq",

	CONSENT: "/consent",
	PRIVACY: "/privacy",
	TERMS: "/terms",
	COOKIES: "/cookies",
	SUBSCRIPTION_AGREEMENT: "/lab-test-order-agreement",
	COMMUNICATION_POLICY: "/communication-policy",

	SETTINGS: "/settings",

	SIGN_UP: "/sign-up",
	SIGN_IN: "/sign-in",
	SIGN_OUT: "/sign-out",

	PASSWORD_FORGET: '/pw-forget',
	PASSWORD_SET: "/pw-set",
	PASSWORD_RESET: "/pw-reset",

	NOT_FOUND: "/not-found",
	NO_ACCESS: "/no-access",

	VERIFY_EMAIL: "/verify-email",
	VERIFY_PHONE: "/verify-phone",
	MFA_SETUP: "/mfa-setup",
	USER_ACTION: "/userAction",

	OPT_OUT: "/opt-out",

	START_TEST: '/start-test',

	INSURANCE_UPDATE: "/insurance-update",

	COVERED_ENTITY: '/covered-entity',
	AFFILIATE: '/affiliate',
	PARTNER: '/partner',

	ADMIN: "/admin",
	MANAGE_STATISTICS: "/admin/statistics",
	MANAGE_RETENTION_STATISTICS: "/admin/retention-statistics",
	MANAGE_REP_STATISTICS: "/admin/rep-statistics",
	MANAGE_REP_PERFORMANCE: "/admin/rep-performance",
	MANAGE_REP_SLA: "/admin/rep-sla",
	MANAGE_FUNNEL_STATISTICS: '/admin/funnel-statistics',
	MANAGE_FUNNEL_ANALYTICS: '/admin/funnel-analytics',
	MANAGE_SITE_VISITS: '/admin/site-visits',
	MANAGE_SITE_EVENTS: '/admin/site-events',
	MANAGE_SITE_EVENT_STEP_SUMMARY: '/admin/site-event-step-summary',
	MANAGE_FINANCIALS: "/admin/financials",
	MANAGE_SALES_BY_STATE: "/admin/sales-by-state",
	MANAGE_USERS: "/admin/users",
	MANAGE_LEADS: '/admin/leads',
	MANAGE_LEADS_RAW: '/admin/data/leads',
	MANAGE_LEADS_PENDING_RAW: '/admin/data/leads/pending',
	MANAGE_LEADS_ISSUES_RAW: '/admin/data/leads/issues',
	MANAGE_LEADS_SUPPORT_CALL_RAW: '/admin/data/leads/need-support-call',
	MANAGE_LEADS_SUBMITTED_RAW: '/admin/data/leads/submitted',
	MANAGE_LEADS_DUPLICATES_RAW: '/admin/data/leads/duplicates',
	MANAGE_LEADS_FRAUD_RAW: '/admin/data/leads/fraud',
	MANAGE_MESSAGES: "/admin/messages",
	MANAGE_REPORTS: "/admin/reports",
	MANAGE_AUTH_USERS: "/admin/auth-users",
	MANAGE_SUBSCRIPTIONS: "/admin/subscriptions",
	MANAGE_SUBSCRIPTIONS_RAW: "/admin/data/subscriptions",
	MANAGE_CANCELLED_SUBSCRIPTIONS: "/admin/cancelled-subscriptions",
	MANAGE_CANCELLED_SUBSCRIPTIONS_RAW: "/admin/data/cancelled-subscriptions",
	MANAGE_CANCELLATION_REQUESTS: "/admin/cancellation-requests",
	MANAGE_CANCELLATION_REQUESTS_RAW: "/admin/data/cancellation-requests",
	MANAGE_ORDERS: "/admin/orders",
	MANAGE_VOUCHER_ORDERS: "/admin/orders/vouchers",
	MANAGE_PRESCRIPTION_ORDERS: "/admin/orders/prescriptions",
	MANAGE_ORDERS_RAW: "/admin/data/orders",
	MANAGE_ORDER_GROUPS: "/admin/order-groups",
	MANAGE_ORDER_GROUPS_RAW: "/admin/data/order-groups",
	MANAGE_COVERED_ENTITIES: "/admin/covered-entities",
	MANAGE_COVERED_ENTITY_USERS: '/admin/covered-entity-users',
	MANAGE_EMAIL_TEMPLATES: "/admin/email-templates",
	MANAGE_SHIPPING_CLASSES: '/admin/shipping-classes',
	MANAGE_SHIPPING_METHODS: '/admin/shipping-methods',
	MANAGE_COUPONS: '/admin/coupons',
	MANAGE_PRODUCT_CATEGORIES: '/admin/product-categories',
	MANAGE_ENROLLMENT_GROUPS: '/admin/enrollment-groups',
	MANAGE_PRODUCT_FAMILIES: '/admin/product-families',
	MANAGE_OFFER_GROUPS: '/admin/offer-groups',
	MANAGE_COMMERCIAL_EQUIVALENCY_GROUPS: '/admin/commercial-equivalency-groups',
	MANAGE_FUNNEL_CHOICE_SETS: '/admin/funnel-choice-sets',
	MANAGE_MEDICATION_TRANSITION_RULES: '/admin/medication-transition-rules',
	MANAGE_PRODUCT_IDENTITY_AUDIT: '/admin/product-identity-audit',
	MANAGE_PRODUCTS: '/admin/products',
	MANAGE_ADD_ON_PRODUCTS: '/admin/add-on-products',
	MANAGE_ENCOUNTERS: '/admin/encounters',
	MANAGE_ENCOUNTERS_RAW: '/admin/data/encounters',
	MANAGE_PRESCRIPTIONS: '/admin/prescriptions',
	MANAGE_PRESCRIPTIONS_RAW: '/admin/data/prescriptions',
	MANAGE_PRESCRIPTION_GROUPS_RAW: '/admin/data/prescription-groups',
	MANAGE_PAYMENTS: '/admin/payments',
	MANAGE_PAYMENTS_RAW: '/admin/data/payments',
	MANAGE_TRANSACTIONS: '/admin/transactions',
	MANAGE_TRANSACTIONS_RAW: '/admin/data/transactions',
	MANAGE_VOUCHERS: '/admin/vouchers',
	MANAGE_VOUCHERS_RAW: '/admin/data/vouchers',
	MANAGE_SURVEYS: '/admin/surveys',
	MANAGE_AGREEMENTS: '/admin/agreements',
	MANAGE_PROGRAMS: '/admin/programs',
	MANAGE_AFFILIATES: '/admin/affiliates',
	MANAGE_AFFILIATE_USERS: '/admin/affiliate-users',
	MANAGE_PARTNERS: '/admin/partners',
	MANAGE_PARTNER_USERS: '/admin/partner-users',
	MANAGE_CAMPAIGNS: '/admin/campaigns',
	MANAGE_SMS_TEMPLATES: '/admin/sms-templates',
	MANAGE_METRICS: '/admin/metrics',
	MANAGE_CONDITIONS: '/admin/conditions',
	MANAGE_VENDORS: '/admin/vendors',
	MANAGE_LEAD_AFFILIATE_AGGREGATES: '/admin/leads/affiliate-aggregates',
	MANAGE_LEAD_AGGREGATES: '/admin/leads/aggregates',
	MANAGE_COUPON_USES: '/admin/coupon-uses',
	MANAGE_ANALYTICS: '/admin/analytics',
	MANAGE_AFFILIATE_CONVERSIONS: '/admin/affiliate-conversions',
	MANAGE_AFFILIATE_PAYOUTS: '/admin/affiliate-payouts',
	MANAGE_PARTNER_CONVERSIONS: '/admin/partner-conversions',
	MANAGE_PARTNER_PAYOUTS: '/admin/partner-payouts',
	MANAGE_REP_CONVERSIONS: '/admin/rep-conversions',
	MANAGE_REP_PAYOUTS: '/admin/rep-payouts',
	MANAGE_PROVIDERS: '/admin/providers',
	MANAGE_BIOMARKERS: '/admin/biomarkers',
	MANAGE_LAB_PANELS: '/admin/lab-panels',

	MANAGE_ARTICLE_CATEGORIES: '/admin/article-categories',
	MANAGE_ARTICLES: '/admin/articles',
	MANAGE_ASSETS: '/admin/content-management',

	MANAGE_REPS: '/admin/reps',
	MANAGE_HELP_STAFF: '/admin/help-staff',
	MANAGE_ADMINS: '/admin/admins',

	MANAGE_CHECK_INS: '/admin/progress-logs',
	MANAGE_CHECK_INS_RAW: '/admin/data/progress-logs',
	MANAGE_MEAL_PLANS: '/admin/meal-plans',
	MANAGE_MEAL_PLANS_RAW: '/admin/data/meal-plans',
	MANAGE_MEALS: '/admin/meals',
	MANAGE_MEALS_RAW: '/admin/data/meals',
	MANAGE_EVENTS: '/admin/events',
	MANAGE_EVENTS_RAW: '/admin/data/events',
	MANAGE_EVENT_CHECK_INS: '/admin/event-checkins',
	MANAGE_EVENT_CHECK_INS_RAW: '/admin/data/event-checkins',

	MANAGE_ACCOUNTS_PAYABLE_ORDERS: '/admin/accounts-payable/orders',
	MANAGE_ACCOUNTS_PAYABLE_ENCOUNTERS: '/admin/accounts-payable/encounters',

	MANAGE_WEBHOOK_LOGS: '/admin/logs/webhook',
	MANAGE_API_LOGS: '/admin/logs/api',
	MANAGE_CHANGELOG_LOGS: '/admin/logs/changelog',
	MANAGE_EVENTS: '/admin/events',
	MANAGE_REFERRALS: '/admin/referrals',
	MANAGE_REFERRAL_CODES: '/admin/referral-codes',
	MANAGE_COMMUNITIES: '/admin/communities',
	MANAGE_GROUPS: '/admin/groups',

	MANAGE_TASKS: '/admin/tasks',
	MANAGE_SUPPORT: '/admin/support',
	MANAGE_SUPPORT_INBOX: '/admin/support/inbox',
	MANAGE_SUPPORT_SPLIT: '/admin/support/split',
	MANAGE_SUPPORT_OVERSIGHT: '/admin/support/oversight',
	SUPPORT_TICKET_DETAIL: '/admin/support/ticket',
	MANAGE_SUPPORT_REPLY_TEMPLATES: '/admin/support/reply-templates',
	MANAGE_SUPPORT_SNIPPETS: '/admin/support/snippets',
	AGENT_DASHBOARD: '/admin/agent-dashboard',
	AGENT_CHECKOUT: '/admin/agent-checkout',
	REP_DASHBOARD_PREVIEW: '/admin/rep-dashboard-preview',

	MANAGE_EMAILS: "/admin/emails",

	LAB: '/lab',
	CLINICIAN: '/clinician',

	PRODUCT_DETAILS: '/shop/p',

	WEIGHT_LOSS_FUNNEL: '/f/wl',
	LONGEVITY_FUNNEL: '/f/l',
	METABOLIC_SUPPORT_FUNNEL: '/f/ms',
	SKIN_CARE_FUNNEL: '/f/sc',
	FEMALE_HRT_FUNNEL: '/f/fhrt',
	GLP1_MICRODOSING_FUNNEL: '/f/gmd',

	PROGRAM_DETAILS: '/pr',
	PROGRAM_FUNNEL: '/f',
	PROGRAM_FUNNEL_CHECKOUT: '/fc',

	SHOP: '/shop',

	PRODUCT_CATEGORY_DETAILS: '/shop/c',

	COVID_19_LANDING: "/pr/c19",
	SEMAGLUTIDE_LANDING: "/shop/c/se",
	TIRZEPATIDE_LANDING: "/shop/c/ti",
	NADPLUS_LANDING: "/shop/c/na",
	METFORMIN_LANDING: "/shop/c/me",
	GLUTATHIONE_LANDING: "/shop/c/gl",


	COMPOUNDED_SEMAGLUTIDE_PRODUCT_PAGE: "/shop/p/se",
	OZEMPIC_PRODUCT_PAGE: "/shop/p/oz",
	COMPOUNDED_TIRZEPATIDE_PRODUCT_PAGE: "/shop/p/ti",
	ZEPBOUND_PRODUCT_PAGE: "/shop/p/ze",

	ENCOUNTER: '/e',

	ACCOUNT: "/account",
	MY_INVOICES: "/account/invoices",
	MY_ORDERS: "/account/orders",
	MY_PRESCRIPTIONS: "/account/prescriptions",
	MY_SUBSCRIPTIONS: "/account/subscriptions",
	MY_MEDICATION_JOURNAL: "/account/medication-journal",
	SUBSCRIPTION_CANCEL: "/subscription-cancel",
	SUBSCRIPTION_CHANGE: "/subscription-change",
	SUBSCRIPTION_MEDICATION_CHANGE: "/subscription-medication-change",
	SUBSCRIPTION_REACTIVATION: "/account/subscription-reactivation",
	MY_MESSAGES: "/account/messages",
	MY_CONVERSATIONS: "/account/chats",
	MY_SUPPORT_TICKETS: "/account/support",
	MY_SUPPORT_TICKET_DETAIL: "/account/support/ticket",
	MY_NOTIFICATIONS: "/account/notifications",
	PROFILE: "/account/profile",
	MY_ADDRESSES: "/account/addresses",
	MY_PAYMENT_METHODS: "/account/payment-methods",
	MY_MFA: "/account/mfa",
	PASSWORD_CHANGE: "/account/change-password",
	CHANGE_PHONE: "/account/change-phone",
	MY_CONTACT: "/account/contact",
	PAY_NOW: "/pay",

	BLOG: '/blog',
	ARTICLE_DETAILS: '/blog/p',
	ARTICLE_CATEGORY_DETAILS: '/blog/c',

	WEIGHT_LOSS_CHECK_IN: '/account/log-progress/wl',
	LONGEVITY_CHECK_IN: '/account/log-progress/l',
	METABOLIC_SUPPORT_CHECK_IN: '/account/log-progress/ms',
	SKIN_CARE_CHECK_IN: '/account/log-progress/sc',
	FEMALE_HRT_CHECK_IN: '/account/log-progress/fhrt',
	GLP1_MICRODOSING_CHECK_IN: '/account/log-progress/gmd',
	MY_CHECK_INS: '/account/progress-logs',

	WEIGHT_LOSS_MEAL_PLAN_SETUP: '/account/meal-plan-setup/wl',
	LONGEVITY_MEAL_PLAN_SETUP: '/account/meal-plan-setup/l',
	METABOLIC_SUPPORT_MEAL_PLAN_SETUP: '/account/meal-plan-setup/ms',
	SKIN_CARE_MEAL_PLAN_SETUP: '/account/meal-plan-setup/sc',
	FEMALE_HRT_MEAL_PLAN_SETUP: '/account/meal-plan-setup/fhrt',
	GLP1_MICRODOSING_MEAL_PLAN_SETUP: '/account/meal-plan-setup/gmd',
	MEAL_PLAN_SETUP: '/account/meal-plan-setup',
	MY_MEAL_PLANS: '/account/meal-plans',
	MEAL_PLAN_REQUEST: '/account/meal-plans/request',


	MY_HABIT_TRACKER: '/account/habit-tracker',
	MANAGE_HABIT_TEMPLATES: '/admin/habit-templates',
	MANAGE_USER_HABITS: '/admin/user-habits',
	MANAGE_WALLETS: '/admin/wallets',

	EVENT_CHECK_IN: '/account/event',
	MY_TREATMENTS: '/account/treatments',
	MY_LABS: '/account/labs',
	MY_SUPPORT_GROUPS: '/account/support-groups',
	MY_STORE: '/account/store',
	MY_EVENTS: '/account/events',

	MY_REFERRALS: '/account/referrals',

	MANAGE_EMAIL_CAMPAIGN: '/admin/email-campaign',
	MANAGE_INTEGRATION_TOOLS: '/admin/settings/tools',
	MANAGE_SCHEDULED_FUNCTIONS: '/admin/settings/scheduled-functions',

	MANAGE_AUTOMATIONS: '/admin/automations',
	AUTOMATION_DETAIL: '/admin/automations/rule',

	MANAGE_KNOWLEDGE_BASE: '/admin/knowledge-base',
	HELP_ARTICLE: '/help/article',
	HELP_CATEGORY: '/help/category'
};

export default ROUTES;
